/* eslint class-methods-use-this: 0 */
class Image {
    constructor(values) {
        if (values) {
            Object.keys(values).forEach(k => {
                if (this.constructor.prototype.hasOwnProperty(k)) {
                    this[k] = values[k];
                }
            });
        }
    }

    get type() {
        return 'Image';
    }

    set id(id) {
        this._id = id;
    }

    get id() {
        return this._id;
    }

    set rotationAngle(rotationAngle) {
        this._rotationAngle = rotationAngle;
    }

    get rotationAngle() {
        return this._rotationAngle;
    }

    set fileName(fileName) {
        this._fileName = fileName;
    }

    get fileName() {
        return this._fileName;
    }

    get opacity() {
        return this._opacity;
    }

    set opacity(opacity) {
        this._opacity = opacity;
    }

    get title() {
        return this._title;
    }

    set title(title) {
        this._title = title;
    }

    get createdAtZoomLevel() {
        return this._createdAtZoomLevel;
    }

    set createdAtZoomLevel(createdAtZoomLevel) {
        this._createdAtZoomLevel = createdAtZoomLevel;
    }

    get minZoom() {
        return this._minZoom;
    }

    set minZoom(minZoom) {
        this._minZoom = minZoom;
    }

    get maxZoom() {
        return this._maxZoom;
    }

    set maxZoom(maxZoom) {
        this._maxZoom = maxZoom;
    }

    get description() {
        return this._description;
    }

    set description(description) {
        this._description = description;
    }

    get topLeftPoint() {
        return this._topLeftPoint;
    }

    set topLeftPoint(topLeftPoint) {
        this._topLeftPoint = topLeftPoint;
    }

    get bottomRightPoint() {
        return this._bottomRightPoint;
    }

    set bottomRightPoint(bottomRightPoint) {
        this._bottomRightPoint = bottomRightPoint;
    }

    get legendOrder() {
        return this._legendOrder;
    }

    set legendOrder(legendOrder) {
        this._legendOrder = legendOrder;
    }

    get includedInLegend() {
        return this._includedInLegend;
    }

    set includedInLegend(includedInLegend) {
        this._includedInLegend = includedInLegend;
    }


    equals(that) {
        return (this.id === that.id &&
        this.type === that.type &&
        this.opacity === that.opacity &&
        this.rotationAngle === that.rotationAngle &&
        this.title === that.title &&
        this.fileName === that.fileName &&
        this.createdAtZoomLevel === that.createdAtZoomLevel &&
        this.minZoom === that.minZoom &&
        this.maxZoom === that.maxZoom &&
        this.includedInLegend === that.includedInLegend &&
        this.description === that.description &&
        this.topLeftPoint === that.topLeftPoint &&
        this.legendOrder === that.legendOrder &&
        this.bottomRightPoint === that.bottomRightPoint);
    }

    clone() {
        return new Image({
            id: `${this.id}`,
            rotationAngle: this.rotationAngle,
            fileName: this.fileName,
            opacity: this.opacity,
            title: this.title,
            createdAtZoomLevel: this.createdAtZoomLevel,
            minZoom: this.minZoom,
            maxZoom: this.maxZoom,
            includedInLegend: this.includedInLegend,
            description: this.description,
            topLeftPoint: this.topLeftPoint,
            bottomRightPoint: this.bottomRightPoint,
            legendOrder: this.legendOrder,
        });
    }

    toJSON() {
        return {
            id: `${this.id}`,
            type: this.type,
            fileName: this.fileName,
            rotationAngle: this.rotationAngle,
            opacity: this.opacity,
            title: this.title,
            createdAtZoomLevel: this.createdAtZoomLevel,
            minZoom: this.minZoom,
            maxZoom: this.maxZoom,
            includedInLegend: this.includedInLegend,
            description: this.description,
            topLeftPoint: this.topLeftPoint,
            bottomRightPoint: this.bottomRightPoint,
            legendOrder: this.legendOrder,
        };
    }
}

export default Image;
